import revive_payload_client_4sVQNw7RlN from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import router_jmwsqit4Rs from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/opt/atlassian/pipelines/agent/build/frontend/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import prefetch_client_5tzzN0oIVL from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_KlVwwuJRCL from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/@storyblok/nuxt/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import a11y_client_Gy9I72hejC from "/opt/atlassian/pipelines/agent/build/frontend/plugins/a11y.client.ts";
import bus_client_bku2rtFYG7 from "/opt/atlassian/pipelines/agent/build/frontend/plugins/bus.client.ts";
import gtm_client_OzmBuHLRIb from "/opt/atlassian/pipelines/agent/build/frontend/plugins/gtm.client.ts";
import rte_k6B5UeqrPL from "/opt/atlassian/pipelines/agent/build/frontend/plugins/rte.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  prefetch_client_5tzzN0oIVL,
  plugin_KlVwwuJRCL,
  chunk_reload_client_UciE0i6zes,
  a11y_client_Gy9I72hejC,
  bus_client_bku2rtFYG7,
  gtm_client_OzmBuHLRIb,
  rte_k6B5UeqrPL
]